import type {PublicMethodUtils} from '@wix/document-services-types'
import type {StylableEditorPublicAPI} from '@wix/document-services-public-types'
import {stylableEditorAPI} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<StylableEditorPublicAPI> {
    const {
        getStylableEditorInstance,
        update,
        createEmptyStyle,
        removeRefIfEmptyStyle,
        setQuickChange,
        revertQuickChange,
        forceState,
        revertForceState,
        mergeStylesheets
    } = stylableEditorAPI

    return {
        methods: {
            components: {
                stylable: {
                    update: publicMethodUtils.defineDataManipulationAction(update),
                    createEmptyStyle: publicMethodUtils.defineDataManipulationAction(createEmptyStyle),
                    removeRefIfEmptyStyle: publicMethodUtils.defineDataManipulationAction(removeRefIfEmptyStyle),
                    getEditorInstance: publicMethodUtils.defineGetter(getStylableEditorInstance),
                    quickChange: publicMethodUtils.defineAction(setQuickChange),
                    revertQuickChange: publicMethodUtils.defineAction(revertQuickChange),
                    forceState: publicMethodUtils.defineAction(forceState),
                    revertForceState: publicMethodUtils.defineAction(revertForceState),
                    mergeStylesheets: publicMethodUtils.defineGetter(mergeStylesheets)
                }
            }
        }
    }
}
